module.exports = __webpack_public_path__ + "static/media/loc1_img7.e1b32623.jpg";